import './EmployeeNameCell.css';

const MAX_NAME_LENGTH = 40;

const truncateName = (name) => {
  if (name.length > MAX_NAME_LENGTH) {
    return `${name.slice(0, MAX_NAME_LENGTH)}...`;
  }
  return name;
};

export const EmployeeNameCell = ({name, badge}) => {
  return (
    <div className='employee-name-cell'>
      <div className='employee-name-cell-text'>{truncateName(name)}</div>
      {badge && <div className='employee-name-cell-badge'>{badge}</div>}
    </div>
  );
};
